import { List, ListItemButton, ListItemIcon, ListItemText, styled } from '@mui/material';

import { ThemeProvider } from '/common';
import { checkIsMacos } from '/helpers';

export const StyledListItemIcon = styled(ListItemIcon)`
  color: inherit;
`;

export const StyledListItemText = styled(ListItemText)`
  color: inherit;
`;

export const StyledList = styled(List)`
  color: inherit;
`;

export const StyledListItemButton = styled(ListItemButton)<{ selected: boolean }>(({ theme, selected }) => ({
  paddingRight: checkIsMacos() ? theme.spacing(2) : 0,

  ...(selected && {
    backgroundColor: `${theme.palette.background.paper} !important`,

    color: ThemeProvider.getAppropriateStyles(
      theme.palette.mode,
      theme.palette.primary.main,
      theme.palette.text.disabled
    ),
    '&:hover': {
      backgroundColor: `${theme.palette.action.selected} !important`,
    },
  }),
}));
